import * as signalR from "@microsoft/signalr";
import { apiConfig } from '../config/apiConfig';

export default {
  dataUpdateHub: (): signalR.HubConnection => new signalR.HubConnectionBuilder().withUrl(`${apiConfig.url}/dataupdate`).build(),

}